/* global angular */
( function () {
	'use strict';

	function pdfTemplateAttachPd () {
		// obsObj = observation/section/indicator object/data
		// masterpdList = list of pd info that resides on the masterPrescribeResources attribute
		// level = 0 -> observation, 1 -> section, 2 -> indicator
		function attachPd ( obsObj, masterpdList, level ) {
			var indentation   = level * 10;
			var imageName     = [ 'video.jpg', 'file.jpg', 'mc-badge.jpg' ];
			var attachPdLabel = {
				'text'     : 'Assigned PD:',
				'margin'   : [ indentation, 0, 0, 0 ],
				'fontSize' : 9
			};

			function mapPd ( item ) {
				var offset   = parseInt( masterpdList[ item ].type, 10 ) - 1;
				var imageObj = {
					'image'  : imageName[ offset ],
					'width'  : 10,
					'margin' : [ 0, 1, 0, 0 ]
				};

				var textObj = {
					'text'  : masterpdList[ item ].contentName || ' ',
					'style' : 'attachedPd'
				};

				return {
					'widths'  : [ '5%', '*' ],
					'margin'  : [ indentation, 0, 0, -5 ],
					'columns' : [ imageObj, textObj ]
				};
			}

			var obsPrescribed = obsObj.prescribedResources.map( function ( item ) {
				return item.id || item;
			} );

			var stackObj  = obsPrescribed.map( mapPd );

			stackObj.unshift( attachPdLabel );
			return { 'stack' : stackObj };
		}

		return attachPd;
	}

	pdfTemplateAttachPd.$inject = [];

	angular
		.module( 'app.components' )
		.factory( 'pdfTemplateAttachPd', pdfTemplateAttachPd );
} )();
